<script setup lang="ts">
import { NxtButton, NxtJsonVisualizer, NxtLink } from '@nxtpeople/nxt-styles';
import { useKeycloak } from '@nxtpeople/nxt-vue-keycloak';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

const { query } = useRoute();
const { error_code, error_title, error_message, error_action } = query;
const { keycloak, isAuthenticated } = useKeycloak();
const { state } = useStore();

function refresh() {
   window.location.replace('/');
}

function logout() {
   keycloak.logout({ redirectUri: window.location.origin });
}

function goHome() {
   window.location.replace(window.location.origin + '/');
}

const errorJson = computed(() => {
   try {
      const json = JSON.parse(error_message as string);
      if (!json.config) return null;

      const error = {
         url: `${json.config.baseURL}${json.config.url}`,
         params: json.config.params,
      };

      return JSON.stringify(error, null, 2);
   } catch {
      return null;
   }
});
</script>

<template>
   <div class="error">
      <div class="error__code">{{ error_code as string }}</div>
      <h1>{{ error_title as string }}</h1>
      <div v-if="state.isDev && errorJson">
         <NxtJsonVisualizer
            class="error__json"
            :json="errorJson"
         />
      </div>

      <p v-else>
         {{ error_message }}
      </p>

      <div class="error__actions">
         <NxtButton
            v-if="error_action === 'refresh'"
            @click="refresh"
         >
            {{ $t('reload-page') }}
         </NxtButton>
         <template v-if="isAuthenticated">
            <!-- Home or logout -->
            <NxtLink
               v-if="error_action === 'home-or-logout'"
               @on-click="goHome"
            >
               {{ $t('back-to-home-screen') }}
            </NxtLink>

            <NxtButton
               v-if="error_action === 'home-or-logout' || error_action === 'logout'"
               @click="logout"
            >
               {{ $t('logout') }}
            </NxtButton>
         </template>
      </div>
   </div>
</template>

<style scoped lang="scss">
.error {
   padding: 0 toRem(48);
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
   overflow: auto;
   height: 100%;

   h1 {
      margin: unset;
      margin: toRem(12) 0 toRem(8) 0;
   }
   p {
      margin: unset;
   }
   button {
      margin: toRem(12) 0;
   }
}
.error__code {
   color: var(--nxt-main-hover);
   font-size: toRem(100);
   font-weight: 600;
   line-height: toRem(100);
   display: flex;
   align-items: center;
}

.error__json {
   max-height: 35rem;
   overflow: auto;
   max-width: calc(100vw - 20rem);
}

.error__actions {
   display: flex;
   gap: var(--nxt-gutter);
}
</style>
